export default __webpack_public_path__ + "static/media/Church.1493c043.png";